import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-text">
            <span>
              <strong>Гостиница «Белая»</strong> - проживание и услуги миграционного учета в Уфе.{' '}
            </span>
            <span className="footer-highlight">
              © 15 лет работаем для Вас !
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;